import { MeddreamRepository } from '../data/meddream';

export const Meddream = {
  namespaced: true,

  state: {
    meddreamUrls: {},
  },

  getters: {
    getMeddreamKey:
      (state) =>
      (studies, readOnly = false, caseId = null) => {
        const key = MeddreamRepository.getIndexKey(studies, readOnly);

        if (!state.meddreamUrls[key]) {
          MeddreamRepository.studiesUrl(studies, readOnly, caseId);
        }

        return key;
      },

    getMeddreamUrl:
      (state) =>
      (studies, readOnly = false) => {
        const key = MeddreamRepository.getIndexKey(studies, readOnly);

        if (!state.meddreamUrls[key]) {
          MeddreamRepository.studiesUrl(studies, readOnly);

          return null;
        }

        return state.meddreamUrls[key];
      },
  },

  mutations: {
    updateMeddreamUrls(state, urls) {
      state.meddreamUrls = { ...urls };
    },
  },

  actions: {
    registerMeddream(context) {
      MeddreamRepository.registerStore(context);
    },
  },
};
